<template>
  <div :class="jel_getClassObject(content)">
    <!-- TODO: si content.modeInscription == 'inscription' 
               alors ajouter validation de non-existence
               + permettre la saisie du username (à confirmer) -->
    <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
    <ValidationProvider
      v-slot="validationContext"
      :name="content.libNomUtilisateur"
      rules="max:128"
      tag="div"
    >
      <b-form-group :label="content.libNomUtilisateur" label-for="nomUtilisateur">
        <b-form-input
          :id="content.idHTML ? content.idHTML : 'nomUtilisateur'"
          v-model="nomUtilisateur"
          v-remove-extra-spaces
          trim
          maxlength="128"
          type="text"
          autocomplete="off"
          :state="getValidationState(validationContext)"
        />
        <ErreurValidation
          id="nomUtilisateur-live-feedback"
          :message="validationContext.errors[0]"
        ></ErreurValidation>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';

export default {
  name: 'FormulaireNomUtilisateur',

  components: { ErreurValidation },
  props: { content: { type: Object, required: true } },
  computed: {
    nomUtilisateur: {
      get() {
        return this.$store.state.compte.nomUtilisateur;
      },
      set(value) {
        this.$store.commit('compte/SET_NOM_UTILISATEUR', value);
      },
    },
  },

  created() {
    this.$store.state.compte.nomUtilisateur = '';
    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
    this.beforeWindowUnload();
  },
  methods: {
    beforeWindowUnload(e) {
      // Reset du compte
      this.$store.commit('compte/RESET');
    },
    getValidationState({ validated, valid = null }) {
      // Uniquement si la validation a été effectuée une fois et que le champ est invalide
      this.validated = validated;
      if (validated && !valid) {
        return valid;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
